/*
 * Cabeçalho do tópico: o título grande e, embaixo, a categoria e as
 * etiquetas — sem a faixa colorida que o flarum/tags pinta
 * com a cor da primeira tag. Os ícones de status do core (fixado, trancado…)
 * continuam antes do título.
 */
import { extend } from 'flarum/common/extend';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import { discussionBadges } from '../utils/tags';

/** Classes que o flarum/tags põe no hero para pintá-lo com a cor da tag. */
const COLORED_CLASS = /^(DiscussionHero--colored|text-contrast--\w+)$/;
export default function installHero() {
  extend(DiscussionHero.prototype, 'items', function (items) {
    // O rótulo de tags do flarum/tags vira a linha de badges,
    // depois do título e não antes.
    if (items.has('tags')) items.remove('tags');
    const badges = discussionBadges(this.attrs.discussion);
    if (badges) {
      items.add('canelaBadges', m("div", {
        className: "CanelaTopicHero-badges"
      }, badges), -10);
    }
  });
  extend(DiscussionHero.prototype, 'view', function (vnode) {
    if (!vnode || !vnode.attrs) return;

    // O título mora no cartão branco: a cor da tag como fundo não combina, e o
    // contraste calculado pelo tags deixaria o texto branco sobre branco.
    delete vnode.attrs.style;
    vnode.attrs.className = String(vnode.attrs.className || '').split(' ').filter(name => name && !COLORED_CLASS.test(name)).concat('CanelaTopicHero').join(' ');
  });
}
flarum.reg.add('ramon-canela', 'forum/topic/hero', installHero);